(function () {
  'use strict';

  angular
    .module('doubleSectorCount')
    .controller('doubleSectorCountCtrl', doubleSectorCountCtrl);

  function doubleSectorCountCtrl(CommonMasterData, doubleSectorCountService ,MessageService, $compile,$scope,StorageServices,TabService,applicationConstants) {
    var vm = this;
    vm.ctrlName = 'doubleSectorCountCtrl';

    vm.model = {
      searchPanelToggle: true,
      width: window.screen.width,
      height:window.screen.height,
      searchOnGoing: false,
      totalNumberOfRecords:null,
      searchCriteria: {
        fromDate: null,
        toDate: null,
        crewType: null,
        crewBase: null,
        autoOrManual : null

      },
      masterList: {
        crewTypeList: [],
        crewBaseList :[],
        fromDateFormatInvalid: false,
        toDateFormatInvalid: false,
        fromDateAfterToDate: false,
        autoManualList : [{'autoOrManualCode':'M', 'autoOrManualDesc':'Manual'}, {'autoOrManualCode':'A', 'autoOrManualDesc':'Auto'}]

      },
      lastSearchDates:{
        fromDate:null,
        toDate:null
      },
      doubleSectorCountList: [],
      initialSearchDone: false
    };

    vm.clickOnSearch = function () {
      vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
      vm.model.initialSearchDone = false;
    };

    var dataObject = [];
    var hotSettings = [];
    var hot;

    vm.submitSearch = function (params) {
      doubleSectorCountService.searchDoubleSectorCount(params,
        function (response) {
          vm.model.lastSearchDates.fromDate = vm.model.searchCriteria.fromDate;
          vm.model.lastSearchDates.toDate = vm.model.searchCriteria.toDate;
          vm.model.doubleSectorCountList = response.doubleSectorCountResponseDTOS;
          vm.model.searchPanelToggle = false;
          vm.model.totalNumberOfRecords = response.doubleSectorCountResponseDTOS.length;
          dataObject = vm.dataObject();
          hotSettings = vm.hotSettings();
          hot = new Handsontable(hotElement, hotSettings);
          $compile(hotElement)($scope);
        },
        function (error) {
          MessageService.error(error[0]);
        }
      );
    };

    vm.dataObject = function () {
      var dataObject = [];

      for (var i in vm.model.doubleSectorCountList) {
        dataObject.push({
          ROW_NUMBER : parseInt(i)+1,
          CREW_NAME: vm.model.doubleSectorCountList[i].crewName,
          CREW_ID: vm.model.doubleSectorCountList[i].crewID,
          CREW_TYPE: vm.model.doubleSectorCountList[i].crewType,
          CREW_BASE: vm.model.doubleSectorCountList[i].crewBase,
          DOUBLE_SECTOR_COUNT: vm.model.doubleSectorCountList[i].doubleSectorCount,
          DAYS_OF_DOUBLE_SECTORS: vm.model.doubleSectorCountList[i].daysOfDoubleSectors,
        })
      }
      return dataObject;
    };

    vm.hotSettings = function () {
      var hotSettings = {
        data: dataObject,
        undo: true,
        redo: true,
        copy: true,
        paste: true,
        manualColumnResize: true,
        copyRowsLimit: 1000000,
        colWidths: [vm.model.width * 0.05, vm.model.width * 0.1, vm.model.width * 0.1, vm.model.width * 0.1, vm.model.width * 0.1, vm.model.width * 0.1, vm.model.width * 0.1],
        columns: [
          {
            data: 'ROW_NUMBER',
            type: 'numeric',
            readOnly: true
          },
          {
            data: 'CREW_NAME',
            renderer: 'html',
            readOnly: true
          }, {
            data: 'CREW_ID',
            type: 'text',
            readOnly: true
          },  {
            data: 'CREW_TYPE',
            type: 'text',
            readOnly: true
          },  {
            data: 'CREW_BASE',
            type: 'text',
            readOnly: true
          },

          {
            data: 'DOUBLE_SECTOR_COUNT',
            type: 'text',
            readOnly: true
          },
          {
            data: 'DAYS_OF_DOUBLE_SECTORS',
            type: 'text',
            readOnly: true
          }],

        stretchH: 'all',
        width: vm.model.width * 0.99,
        autoWrapRow: true,
        height: vm.model.height * 0.7,
        rowHeaders: true,
        colHeaders: [
          '',
          'Crew Name',
          'Crew Id',
          'Crew Type',
          'Crew Base',
          'Double Sector Count',
          'Days of Double Sectors'
        ]
      };

      return hotSettings;
    };

    var hotElement = document.querySelector('#hot');


    function setDateValidationFlags() {
      if (isDateFormatInvalid(vm.model.searchCriteria.fromDate)) {
        vm.model.masterList.fromDateFormatInvalid = true;
      } else {
        vm.model.masterList.fromDateFormatInvalid = false;
      }
      if (isDateFormatInvalid(vm.model.searchCriteria.toDate)) {
        vm.model.masterList.toDateFormatInvalid = true;
      } else {
        vm.model.masterList.toDateFormatInvalid = false;
      }
    }


    vm.changeSearchField = function (searchParams, flag) {
      setDateValidationFlags();
      if (!vm.model.masterList.toDateFormatInvalid
        && !vm.model.masterList.fromDateFormatInvalid) {
        if (istoDateBeforeFromDate()) {
          vm.model.masterList.fromDateAfterToDate = true;
        } else {
          vm.model.masterList.fromDateAfterToDate = false;

        }
      } else {
        vm.model.masterList.fromDateAfterToDate = false;
      }

    };


    function isDateFormatInvalid(date) {
      if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
        return true;
      }
      return false;
    }

    function istoDateBeforeFromDate() {
      return moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY")
        .isBefore(
          moment(vm.model.searchCriteria.fromDate,
            "DD/MM/YYYY"));
    };

    (function () {
      CommonMasterData.getCrewTypeList(function (crewTypeList) {
        vm.model.masterList.crewTypeList = crewTypeList;
      }, function () {
        console.log('Crew Type list retrieval error');
      });
      CommonMasterData.getCrewBaseList(function(crewBases) {
        vm.model.masterList.crewBaseList = crewBases;
      }, function() {
        console.log('Crew Base List retrieval error');
      });

    })();
  }
}());
